import { Ref, watch } from 'vue';
import { useStepperStore } from '../../../stores/stepper.store.js';

export function useStore(selectedProducts: Ref<number[]>) {
  watch(selectedProducts, (val: number[]): void => {
    const gifts = useStepperStore().getState().extras.gifts ?? [];
    if (val.length === 0) {
      for (const gift of gifts) useStepperStore().getState().extras.removeGift(gift.variantId);
    } else {
      for (const number of val) {
        if (!gifts.some((gift) => gift.variantId === number)) {
          useStepperStore().getState().extras.addGift(number);
        }
      }
    }
  });
}
